var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1302_39536)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 10L14.9425 11.0575L19.1275 15.25H10V16.75H19.1275L14.9425 20.9425L16 22L22 16L16 10Z",
    fill: "#E2E7EA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1302_39536"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteBack);
export default __webpack_public_path__ + "static/media/white-back.096e7bd7866764a9860955232a1237a8.svg";
export { ForwardRef as ReactComponent };